<template>
  <router-view />
</template>
<script lang="ts" setup>
</script>
<style lang="scss">
.el-message-box__message {
  width: 100% !important;
}
</style>
